var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1501 8.57503C17.1501 13.3109 13.3109 17.1501 8.57503 17.1501C3.83917 17.1501 0 13.3109 0 8.57503C0 3.83917 3.83917 0 8.57503 0C13.3109 0 17.1501 3.83917 17.1501 8.57503ZM15.1324 8.57503C15.1324 12.1966 12.1966 15.1324 8.57503 15.1324C4.95349 15.1324 2.01765 12.1966 2.01765 8.57503C2.01765 4.95349 4.95349 2.01765 8.57503 2.01765C12.1966 2.01765 15.1324 4.95349 15.1324 8.57503ZM23 21.5735L16.5589 15.1324L15.1322 16.5591L21.5733 23.0001L23 21.5735ZM12.1059 8.07061H5.04413V9.07944H12.1059V8.07061Z",
    fill: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoomOut.02c4014b23f69da7a63eb9abfc92755e.svg";
export { ForwardRef as ReactComponent };